class ServiceOrderReportImage {
    constructor (
        contentType,
        fileName,
        formFieldKey,
        serviceOrderReportID
    ) {
        this.contentType = contentType,
        this.fileName = fileName,
        this.formFieldKey = formFieldKey,
        this.serviceOrderReportID = serviceOrderReportID
    }
}

export const ServiceOrderReportImageDefault = () => {
    const serviceOrderReportImage = {
        contentType: "",
        fileName: "",
        formFieldKey: "",
        serviceOrderReportID: 0
    }

    return serviceOrderReportImage
}

export default ServiceOrderReportImage